export default __webpack_public_path__ + "static/media/foodieBooster09.501552c0.png";